import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import {Input, Card,Pagination } from 'antd';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import NewSideBar from '../../components/Sidebar/NewSideBar';
import { app } from '../../config';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

const Causecategories = () => {
  const { t } = useTranslation(['common']);
  const [current, setCurrent] = useState(1);
  const [renderList, setRenderList] = useState([]);
  const [causeCat,setCauseCat] = useState([]);
  const [commonData, setCommonData] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
let {Search}=Input;
  let navigate = useNavigate();
  const token=getTokenfromUserObj();
  useEffect(() => {
    const fetchCauses=async()=>{
      const limit=1000;
      const offset=0;
      const causeCatResp=await axios.get(`${app.URL}/cause/causecat/view`,{headers:{auth:token}});
      causeCatResp.data?setCauseCat(causeCatResp.data.data):[];
      causeCatResp.data?setCommonData(causeCatResp.data.data):[];
      causeCatResp.data?setPagesCount(causeCatResp.data.data.length):[];
      causeCatResp.data?setRenderList(causeCatResp.data.data.slice(0,50)):[];
      
      }
      fetchCauses();

  }, []);

  const addCauseCategory=(e)=>{
    console.log(e);
    navigate('/cause/add_category',{replace:true});
}
const onSearch = async (value) => {
  console.log(value);
  try {
    const result = await axios.get(`${app.URL}/cause/causecat/search/${value}`,{headers:{auth:token}});
    console.log(result.data.data);
    result.data ? setCommonData(result.data.data) : [];
    result.data ? setRenderList(result.data.data.slice(0, 10)) : [];
    result.data ? setPagesCount(result.data.data.length) : 0;

  } catch (e) {
    console.log('Error');
    console.log(e);
    if (e.message) setErr(e.response.data.message);
    setTableShow(false);
  }
};
const handleSearchChange = (e) => {
  console.log(e.target.value);
  if (!e.target.value) {
    setRenderList(causeCat.slice(0,50));
    setCommonData(causeCat);
    setCurrent(1)
    setPagesCount(causeCat.length);
  }
};
const onChange = async (page, pageSize) => {
  console.log(page, pageSize);
  setCurrent(page);
  if (!page) page = 1;
  let limit = pageSize;
  let reqObj = {
    limit,
    offset: limit * (page - 1),
  };
  console.log(reqObj);
  setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
};
  const editcausecategory = (e) => {
    console.log(e);
    localStorage.setItem('causeCategoryId', JSON.stringify(e.causeCategoryId));
    navigate('/cause/editcategory', { replace: true });
  };

  return (
        <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
        <div className='row text-center mt-4'>
          <div className='ml-6 col-lg-7 col-md-12 col-sm-12'>
            <Search
            className='search'
              placeholder='Search by Category'
              onSearch={onSearch}
              onChange={handleSearchChange}
              style={{
                width: 300,
              }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-5 col-md-8 col-sm-12 '>
            <div class='mt-4 fs-3 fw-bold'> {t('Cause Categories')} </div>
          </div>
          <div className='col-lg-5 ml-8 col-md-4 col-sm-12 p-7'>
            <button class='btn btn-primary button' onClick={addCauseCategory}>
              Add Category
            </button>
          </div>
        </div>
        {/* <div className='row'>
          {renderList
            ? renderList.map((cause) => {
              console.log(cause);
                return (
                  <div key={cause.causeCategoryId} class='col-lg-4 col-md-6 col-sm-12 text-black mt-3 mb-3 '>
                    <Card
                      title={<h1 class='fw-bold text-wrap'>{cause.causeCategory}</h1>}
                      bordered={false}
                      style={{
                        width: 250,
                        maxHeight: 350,
                        wordWrap: 'break-word',
                        fontSize: 14,
                      }}
                      class='tbl mt-3'
                    >
                    <p><b class='fw-bold'>Status: </b>{cause.status==="Inactive"?<span style={{color:"red"}}>{cause.status}</span>:<span>{cause.status}</span>}</p>
                      <EditTwoTone
                        className='mt-2'
                        displayName='edit'
                        twoToneColor='blue'
                        style={{ fontSize: '25px' }}
                        onClick={() => {
                          editcausecategory(cause);
                        }}
                      />
                    </Card>
                  </div>
                );
              })
            : ''}
        </div> */}
        <div className='col-lg-7 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             {/* <th>{t("ID")}</th> */}
                             <th style={{width:"350px"}}>{t("Catergory Name")}</th>
                             <th className='pl-3' style={{width:"300px", padding: "12px 33px"}}>{t("Display Position")}</th>
                             <th>{t("Status")}</th>
                             {/* <th>{t("Phone")}</th>
                             <th>{t("User Type")}</th> */}
                             <th> </th>
             </tr>
           </thead>
           <tbody >

             {renderList
               ? renderList.map((output) => (

                   <tr className='row-hover' onClick={() => editcausecategory(output)}>
                     {/* <td style={{width:"160px"}}>{output.causeCategoryId}</td> */}
                     {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                     <td style={{width:"300px"}} >{output.causeCategory?output.causeCategory :"null"}</td>
                     <td className='text-center' style={{width:"300px"}} >{output.displayPosition?output.displayPosition :"null"}</td>
                     <td class='ml-5' style={{width:"300px"}}>{output.status}</td>
                     {/* <td style={{width:"160px"}}>{output.phone}</td>
                   <td style={{width:"160px"}}>{output.userType==="A"?"Admin":output.userType==="D"?"Donor":output.userType==="O"?"Org User":"User"}</td> */}
                     <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={() => editcausecategory(output)} />
                       {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                     </td>
                   </tr>
                 ))
               : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>     
  </div>
        <Pagination style={{ marginTop: '10px' }} onChange={onChange} current={current} defaultCurrent={current} pageSize={50} total={pagesCount} />
      </div>
  );
};

export default Causecategories;
